<div class="__wrap">
  @if (icon()) {
    <mat-icon class="__icon" fontSet="material-icons-outlined">{{ icon() }}</mat-icon>
  }
  <span class="__message">{{ message() }}</span>
</div>
